import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import { Check } from 'styled-cssgg';
import { animated, config, Transition } from '@react-spring/web';
import cx from 'classnames';
const CheckBoxPrefix = styled.span `
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  overflow: hidden;
  width: 16px;
  height: 16px;
  position: relative;
  cursor: pointer;
  border: 0.5px solid var(--border-color);
  input[type='checkbox'] {
    background-color: rgba(0, 0, 0, 0);
    opacity: 0;
    z-index: 1;
    width: 16px;
    height: 16px;
    margin: 0px;
  }
  span[data-role='checkbox-icon'] {
    background-color: var(--primary);
    width: 16px;
    height: 16px;
    display: flex;
    position: absolute;
    align-items: center;
    justify-content: center;
    color: white;
    i {
      --ggs: 0.8;
      position: absolute;
      left: -2px;
    }
  }
`;
const CheckboxContainer = styled.div `
  display: flex;
  align-items: center;
  color: var(--text-color-0);
  gap: 4px;
`;
export const CheckBox = (props) => {
    const [checked, setChecked] = useState(props.defaultChecked);
    const controlled = useMemo(() => {
        return props.checked || checked;
    }, [checked, props.checked]);
    const input = useRef(null);
    useEffect(() => {
        if (input.current) {
            input.current.indeterminate = false;
        }
    }, [input]);
    const handleChecked = useCallback(() => {
        var _a;
        setChecked((prev) => !prev);
        (_a = props.onCheck) === null || _a === void 0 ? void 0 : _a.call(props, !checked);
    }, [props.onCheck, checked]);
    return (React.createElement(CheckboxContainer, { className: cx('checkbox', props.className) },
        React.createElement(CheckBoxPrefix, { className: "checkbox-prefix", "data-role": "checkbox-prefix" },
            React.createElement("input", { type: "checkbox", className: "checkbox-input", "data-role": "checkbox-input", onClick: handleChecked, ref: input }),
            controlled ? (React.createElement(Transition, { items: controlled, from: { opacity: 0 }, enter: { opacity: 1 }, leave: { opacity: 0 }, config: config.stiff, delay: 200 }, (styles, item) => item && (React.createElement(animated.span, { className: "checkbox-icon", style: styles, "data-role": "checkbox-icon" },
                React.createElement(Check, null))))) : null),
        props.children));
};
